import React from 'react';
import { Menu, X, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useSidebar } from '../../context/SideBarConext';

const MenuItem = ({ id, title, items, depth = 0 }) => {
  const { openSections, toggleSection } = useSidebar();
  
  const handleToggle = (e) => {
    e.preventDefault();
    e.stopPropagation(); // Prevent event bubbling
    toggleSection(id);
  };

  return (
    <li className="w-full">
      <details
        open={openSections.sections[id]}
        className="group w-full"
      >
        <summary 
          className="flex items-center justify-between w-full px-4 py-2 text-sm font-medium hover:bg-white/10 cursor-pointer rounded-md transition-colors"
          onClick={handleToggle}
        >
          <span className="text-white">{title}</span>
          <ChevronRight 
            className={`w-4 h-4 text-white transition-transform duration-200 ${
              openSections.sections[id] ? 'rotate-90' : ''
            }`}
          />
        </summary>
        
        <ul className={`mt-1 ml-4 space-y-1 ${depth > 0 ? 'border-l border-white/20 pl-4' : ''}`}>
          {items.map((item, index) => (
            <li key={index}>
              {item.items ? (
                <MenuItem
                  {...item}
                  depth={depth + 1}
                />
              ) : (
                <Link
                  to={item.path}
                  className="block px-4 py-2 text-sm text-white/90 hover:bg-white/10 rounded-md transition-colors"
                  onClick={() => {
                    if (window.innerWidth < 768) {
                      toggleSection('sidebar');
                    }
                  }}
                >
                  {item.title}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </details>
    </li>
  );
};

const Sidebar = () => {
  const { openSections, toggleSidebarOpen, toggleSection } = useSidebar();

  const menuItems = [
    {
      id: 'ops-dashboard',
      title: 'Ops Dashboard',
      items: [
        {
          id: 'orders',
          title: 'Orders',
          items: [
            { title: 'Orders', path: '/order' },
            { title: 'Express Orders', path: '/expressorders' },
            { title: 'Offline Orders', path: '/offlineorders' },
            { title: 'Digital Orders', path: '/digitalorders' }
          ]
        },
        {
          id: 'account',
          title: 'Account',
          items: [
            { title: 'Reseller', path: '/account/reseller' },
            { title: 'Supplier', path: '/account/supplier' },
            { title: 'Shops', path: '/account/shops' },
            { title: 'Campaigns', path: '/account/campaigns' }
          ]
        },
        {
          id: 'inventory',
          title: 'Inventory',
          items: [
            { title: 'Products', path: '/inventory/products' },
            { title: 'Digital Products', path: '/inventory/digital-products' },
            { title: 'Discounts', path: '/inventory/discounts' },
            { title: 'Categories', path: '/inventory/categories' },
            { title: 'Collections', path: '/inventory/collections' }
          ]
        },
        {
          id: 'marketing',
          title: 'Marketing',
          items: [
            { title: 'Marketing Notification', path: '/account/marketing' },
            { title: 'Coupon', path: '/account/coupon' },
            { title: 'App Section', path: '/account/appsection' },
            { title: 'Product Template', path: '/account/producttemplate' }
          ]
        },
        {
          id: 'location',
          title: 'Location',
          items: [
            { title: 'Delivery Locations', path: '/location/delivery-location' },
            { title: 'Pickup Location', path: '/location/pickup-location' }
          ]
        },
        {
          id: 'payment',
          title: 'Payment',
          items: [
            { title: 'Forex Rates', path: '/payment/forex' },
            { title: 'Payout Requests', path: '/payment/payouts' },
            { title: 'Payment Transactions', path: '/payment/payment-transactions' },
            { title: 'Profit Processing', path: '/payment/profit-processing' }
          ]
        },
        {
          id: 'system',
          title: 'System',
          items: [
            { title: 'Config', path: '/system/config' },
            { title: 'System Status', path: '/system/status' }
          ]
        },
        {
          id: 'hr',
          title: 'HR Portal',
          items: [
            { title: 'Manage Employees', path: '/hr/employees' }
          ]
        }
      ]
    }
  ];

  return (
    <>
      <button
        onClick={toggleSidebarOpen}
        className="fixed top-4 left-4 z-50 md:hidden bg-emerald-600 hover:bg-emerald-700 text-white p-2 rounded-lg shadow-lg transition-colors"
      >
        {openSections.sidebar ? <X size={24} /> : <Menu size={24} />}
      </button>

      {openSections.sidebar && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40 md:hidden transition-opacity"
          onClick={toggleSidebarOpen}
        />
      )}

      <aside
        className={`
          fixed md:sticky top-0 left-0 z-50 w-64 h-full
          bg-emerald-600 shadow-xl
          transition-transform duration-300 ease-out
          overflow-hidden
          ${openSections.sidebar ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}
        `}
      >
        <div className="flex items-center justify-center h-16 border-b border-white/20">
          <Link 
            to="/"
            className="text-white text-lg font-semibold hover:text-white/90 transition-colors"
            onClick={() => {
              if (window.innerWidth < 768) {
                toggleSidebarOpen();
              }
            }}
          >
            TENDO DOCS
          </Link>
        </div>

        <nav className="h-[calc(100vh-4rem)] overflow-y-auto">
          <ul className="p-2 space-y-2">
            {menuItems.map((item) => (
              <MenuItem
                key={item.id}
                {...item}
              />
            ))}
          </ul>
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;